import { DIOPTRA_LOGIN_METHOD } from "../constants"

export type Brand = "dioptra" | "icertis" | "vera"

type Branding = {
  name: string
  wordmark: string | null
  managedIcon: string
  supportUrl: string
}

const ICERTIS_SUPPORT_URL = "https://www.icertis.com/contact-us/"

export function isVeraHostname(): boolean {
  return window.location.hostname.endsWith(".vera.icertis.com")
}

export function getBrand(): Brand {
  if (isVeraHostname()) return "vera"
  return localStorage.getItem(DIOPTRA_LOGIN_METHOD) === "icertis" ? "icertis" : "dioptra"
}

const BRANDING: Record<Brand, Branding> = {
  dioptra: {
    name: "Dioptra",
    wordmark: "assets/dioptra-logo.svg",
    managedIcon: "assets/dioptra-icon.svg",
    supportUrl: "mailto:support@dioptra.ai",
  },
  icertis: {
    name: "Icertis",
    wordmark: null,
    managedIcon: "assets/icertis-favicon.png",
    supportUrl: ICERTIS_SUPPORT_URL,
  },
  vera: {
    name: "Vera",
    wordmark: null,
    managedIcon: "assets/vera-icon.png",
    supportUrl: ICERTIS_SUPPORT_URL,
  },
}

export function getBranding(): Branding {
  return BRANDING[getBrand()]
}
